// Loaded-miles upper bounds matching EmptyMilesWarningFlat CSV positions.
// Ranges: 0–100, 101–250, 251–500, 501–750, 751–1000, 1001–1500, 1501–2000, 2001+
const _FLAT_RANGE_MAXES = [100, 250, 500, 750, 1000, 1500, 2000, Infinity];

/**
 * Returns { emptyMiles, limitStr, critical } when empty mileage exceeds the configured
 * threshold, null otherwise. `critical` is true when empty mileage is at least 2× the limit.
 *
 * Priority: if EmptyMilesWarningPercentage is set (non-null, non-empty), use it exclusively.
 * Otherwise fall back to EmptyMilesWarningFlat (8-value CSV, one per loaded-miles range).
 *
 * @param {number|string|null} emptyMiles
 * @param {number|string|null} totalMiles  loaded miles for the trip
 * @param {object|null}        settings    dispatch settings object
 */
export function checkEmptyMileageWarning(emptyMiles, totalMiles, settings) {
    if (!settings || emptyMiles == null) return null;
    const empty = parseFloat(emptyMiles);
    if (isNaN(empty) || empty <= 0) return null;
    const total = parseFloat(totalMiles ?? 0);

    const pctRaw = settings.EmptyMilesWarningPercentage;
    if (pctRaw != null && pctRaw !== '') {
        const pct = parseFloat(pctRaw);
        if (!isNaN(pct) && total > 0 && (empty / total * 100) > pct) {
            const limitMi = total * pct / 100;
            return {
                emptyMiles: empty,
                limitStr: `${pct}% of loaded (${limitMi.toFixed(1)} mi)`,
                critical: empty >= limitMi * 2,
            };
        }
        return null;
    }

    const flatRaw = settings.EmptyMilesWarningFlat;
    if (flatRaw) {
        const thresholds = flatRaw.split(',').map(Number);
        const rangeIdx = _FLAT_RANGE_MAXES.findIndex(max => total <= max);
        const limit = rangeIdx >= 0 ? thresholds[rangeIdx] : null;
        if (limit != null && !isNaN(limit) && empty > limit) {
            return {
                emptyMiles: empty,
                limitStr: `${limit} mi`,
                critical: empty >= limit * 2,
            };
        }
    }

    return null;
}
